import CacheEnabledApiClient from './CacheEnabledApiClient';

class ProductLabelsAPI extends CacheEnabledApiClient {
  constructor() {
    super('product_labels', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'product_label';
  }
}

export default new ProductLabelsAPI();

